import { agTypes } from "./ag-types"
import { TEXT } from "./texts"


export const TRANSLATIONS = {}
interface Index<T> { [key: string]: T }


// Add TEXTS to translations
function addTranslations (root, path) {
  for (var k in root) {
    let value = root[k]
    if (typeof value == 'string') {
      TRANSLATIONS[value] = value
    } else {
      addTranslations(value, [...path, k])
    }
  }
}
addTranslations(TEXT, [])


// CROPS
export type CROP_TYPE = string
const CROP_DATA = {
    "barley":{
        "grain_id":14,
        "name":"Barley",
        "placement":100
    },
    "beans":{
        "grain_id":16,
        "name":"Beans - Soy",
        "placement":200
    },
    "blackbean":{
        "grain_id":22,
        "name":"Black Bean",
        "placement":300
    },
    "broadbean":{
        "grain_id":200,
        "name":"Broadbean",
        "placement":400
    },
    "canary":{
        "grain_id":23,
        "name":"Canary Seed",
        "placement":500
    },
    "durum_wheat":{
        "grain_id":7,
        "name":"Durum Wheat",
        "placement":600
    },
    "flax":{
        "grain_id":17,
        "name":"Flax Seed",
        "placement":700
    },
    "grass_seeds":{
        "grain_id":100,
        "name":"Grass Seeds",
        "placement":800
    },
    "lentils":{
        "grain_id":21,
        "name":"Lentils",
        "placement":900
    },
    "corn":{
        "grain_id":3,
        "name":"Maize",
        "placement":1000
    },
    "mustard_oriental":{
        "grain_id":26,
        "name":"Mustard Oriental",
        "placement":1100
    },
    "oats":{
        "grain_id":2,
        "name":"Oats",
        "placement":1200
    },
    "oil_rape_seed":{
        "grain_id":1,
        "name":"Oil Rape Seed",
        "placement":1300
    },
    "peanut":{
        "grain_id":20,
        "name":"Peanut",
        "placement":1400
    },
    "chick_peas":{
        "grain_id":24,
        "name":"Peas - Chickpeas",
        "placement":1500
    },
    "kidneybean":{
        "grain_id":25,
        "name":"Peas - Kidney Bean",
        "placement":1600
    },
    "peas_yellow":{
        "grain_id":31,
        "name":"Peas Yellow",
        "placement":1700
    },
    "pintobean":{
        "grain_id":28,
        "name":"Pinto Bean",
        "placement":1800
    },
    "pistachio":{
        "grain_id":29,
        "name":"Pistachio",
        "placement":1900
    },
    "rice":{
        "grain_id":18,
        "name":"Rice",
        "placement":2000
    },
    "rye":{
        "grain_id":19,
        "name":"Rye",
        "placement":2100
    },
    "sorghum":{
        "grain_id":15,
        "name":"Sorghum",
        "placement":2200
    },
    "soy_bean":{
        "grain_id":16,
        "name":"Soy Bean",
        "placement":2300
    },
    "sunflower":{
        "grain_id":11,
        "name":"Sunflower",
        "placement":2400
    },
    "sunflower_oil":{
        "grain_id":12,
        "name":"Sunflower Oil",
        "placement":2500
    },
    "wheat":{
        "grain_id":6,
        "name":"Wheat",
        "placement":2600
    },
    "wheat_soft":{
        "grain_id":300,
        "name":"Wheat - Soft",
        "placement":2650
    },
    "yellow_mustard":{
        "grain_id":27,
        "name":"Yellow Mustard",
        "placement":2700
    }  
}
function getCropTranslateKey (key: string) {
  return 'ag.crop.' + key.toLowerCase()
}
export interface ICrop { name: string, title: string, key: string, placement: number }
export const CROPS: Index<ICrop> = {}
for (var k in CROP_DATA) {
  let crop = CROP_DATA[k]
  let trl = getCropTranslateKey(k)
  CROPS[k] = {name: crop.name, title: trl, key: k, placement: crop.placement}
  TRANSLATIONS[trl] = crop.name
}
export let FARMER_CROPS: Index<ICrop> = {}
let p = 100
for (var k in agTypes.farmerCropNames) {
  p += 100
  let trl = getCropTranslateKey(k)
  FARMER_CROPS[k] = {key: k, title: trl, name: agTypes.farmerCropNames[k], placement: p}
  TRANSLATIONS[trl] = agTypes.farmerCropNames[k]
}



// SENSORS 
export enum SENSOR_TYPE {
  TEMP_AND_HUM='temperature-humidity',
  TEMP='temperature', HUM='humidity'
}
export interface ISensorData {
  key: string, name: string, type: SENSOR_TYPE, title: string
}
export function getSensorTranslateKey (type: string, key: string) {
  return "ag.sensor." + type.toLowerCase() + '-' + key.toLowerCase()
}
export const SENSOR_KEYS = ['1', '2', 'ambient']
export const SENSOR_TYPES = [SENSOR_TYPE.TEMP, SENSOR_TYPE.TEMP_AND_HUM, SENSOR_TYPE.HUM]

export type METRIC = 'temperature' | 'humidity' | 'emc'
export const SENSOR_METRICS: METRIC[] = [
  'temperature', 'humidity', 'emc'
]

export const SENSORS: ISensorData[] = []
SENSOR_KEYS.map(k => {
  SENSOR_TYPES.map(t => {
    let trl = getSensorTranslateKey(t, k)
    SENSORS.push({
      key: k, type: t, name: trl, title: trl
    })
    let name = 'Sensor ' + k
    if (k == 'ambient') {
      name = 'Ambient'
    }
    TRANSLATIONS[trl] = name
  })
})



// LANGUAGE
function getLanguageTranslateKey (key: string) {
  return 'ag.language.' + key.toLowerCase()
}
export interface ILanguage {
  locale: string, name: string, name_en: string, name_locale: string
}
const LANGUAGE_DATA = [
  {key: "en", name: "English", name_locale: ""},
  {key: "da", name: "Danish", name_locale: 'Dansk'},
  {key: "fr", name: "French", name_locale: 'Français'},
  {key: "bg", name: "Bulgarian", name_locale: 'български'},
  {key: "cs", name: "Czech", name_locale: 'Čeština'},
  {key: "de", name: "German", name_locale: 'Deutsch'},
  {key: "et", name: "Estonian", name_locale: 'Eesti'},
  {key: "es", name: "Spanish", name_locale: 'Español'},
  {key: "fi", name: "Finnish", name_locale: 'Suomi'},
  {key: "hu", name: "Hungarian", name_locale: 'Magyar'},
  {key: "lt", name: "Lithuanian", name_locale: 'Lietuvių'},
  {key: "lv", name: "Latvian", name_locale: 'Latviešu'},
  {key: "no", name: "Norwegian", name_locale: 'Norsk'},
  {key: "pl", name: "Polish", name_locale: 'Polski'},
  {key: "ro", name: "Romanian", name_locale: 'Română'},
  {key: "ru", name: "Russian", name_locale: 'Русский'},
  {key: "sv", name: "Swedish", name_locale: 'Svenska'},
  {key: "sk", name: "Slovak", name_locale: 'Slovensky'},
  {key: "uk", name: "Ukrainian", name_locale: 'Українська'},

  // new languages added later
  {key: "nl", name: "Dutch", name_locale: 'Nederlands'},
  {key: "pt", name: "Portuguese", name_locale: 'Português'},
  {key: "sl", name: "Slovenian", name_locale: 'Slovenščina'},
  {key: "it", name: "Italian", name_locale: 'Italiano'}
]
export const LOCALES = LANGUAGE_DATA.map(x => x.key)
export const DEFAULT_LOCALE = 'en'

export const LANGUAGES: ILanguage[] = [] 
LANGUAGE_DATA.map(x => {
  let trl = getLanguageTranslateKey(x.key)
  TRANSLATIONS[trl] = x.name
  LANGUAGES.push({locale: x.key, name: trl, name_en: x.name, name_locale: x.name_locale})
})


// COUNTRIES
function getCountryTranslateKey (key: string) {
  return 'ag.country.' + key.toLowerCase()
}
const COUNTRY_DATA = [{"code": "AT", "country": "Austria"}, {"code": "BE", "country": "Belgium"}, {"code": "BG", "country": "Bulgaria"}, {"code": "HR", "country": "Croatia"}, {"code": "CY", "country": "Cyprus"}, {"code": "CZ", "country": "Czech Republic"}, {"code": "DK", "country": "Denmark"}, {"code": "EE", "country": "Estonia"}, {"code": "FI", "country": "Finland"}, {"code": "FR", "country": "France"}, {"code": "DE", "country": "Germany"}, {"code": "GR", "country": "Greece"}, {"code": "HU", "country": "Hungary"}, {"code": "IE", "country": "Ireland"}, {"code": "IT", "country": "Italy"}, {"code": "LV", "country": "Latvia"}, {"code": "LT", "country": "Lithuania"}, {"code": "LU", "country": "Luxembourg"}, {"code": "MT", "country": "Malta"}, {"code": "NL", "country": "Netherlands"}, {"code": "NO", "country": "Norway"}, {"code": "PL", "country": "Poland"}, {"code": "PT", "country": "Portugal"}, {"code": "RO", "country": "Romania"}, {"code": "SK", "country": "Slovakia"}, {"code": "SI", "country": "Slovenia"}, {"code": "ES", "country": "Spain"}, {"code": "SE", "country": "Sweden"}, {"code": "GB", "country": "United Kingdom"}, {"code": "UA", "country": "Ukraine"}]
const TAX_DATA = [{"country": "Austria", "country_code": "AT", "description": "European VAT number\tATU12345678", "prefix": "AT", "type": "eu_vat"}, {"country": "Belgium", "country_code": "BE", "description": "European VAT number\tBE0123456789", "prefix": "BE", "type": "eu_vat"}, {"country": "Bulgaria", "country_code": "BG", "description": "European VAT number\tBG0123456789", "prefix": "BG", "type": "eu_vat"}, {"country": "Croatia", "country_code": "HR", "description": "European VAT number\tHR12345678912", "prefix": "HR", "type": "eu_vat"}, {"country": "Cyprus", "country_code": "CY", "description": "European VAT number\tCY12345678Z", "prefix": "CY", "type": "eu_vat"}, {"country": "Czech Republic", "country_code": "CZ", "description": "\tEuropean VAT number\tCZ1234567890", "prefix": "CZ", "type": "eu_vat"}, {"country": "Denmark", "country_code": "DK", "description": "European VAT number\tDK12345678", "prefix": "DK", "type": "eu_vat"}, {"country": "Estonia", "country_code": "EE", "description": "European VAT number\tEE123456789", "prefix": "EE", "type": "eu_vat"}, {"country": "Finland", "country_code": "FI", "description": "European VAT number\tFI12345678", "prefix": "FI", "type": "eu_vat"}, {"country": "France", "country_code": "FR", "description": "European VAT number\tFRAB123456789", "prefix": "FR", "type": "eu_vat"}, {"country": "Germany", "country_code": "DE", "description": "European VAT number\tDE123456789", "prefix": "DE", "type": "eu_vat"}, {"country": "Greece", "country_code": "GR", "description": "European VAT number\tEL123456789", "prefix": "EL", "type": "eu_vat"}, {"country": "Hungary", "country_code": "HU", "description": "European VAT number\tHU12345678912", "prefix": "HU", "type": "eu_vat"}, {"country": "Ireland", "country_code": "IE", "description": "European VAT number\tIE1234567AB", "prefix": "IE", "type": "eu_vat"}, {"country": "Italy", "country_code": "IT", "description": "European VAT number\tIT12345678912", "prefix": "IT", "type": "eu_vat"}, {"country": "Latvia", "country_code": "LV", "description": "European VAT number\tLV12345678912", "prefix": "LV", "type": "eu_vat"}, {"country": "Lithuania", "country_code": "LT", "description": "European VAT number\tLT123456789123", "prefix": "LT", "type": "eu_vat"}, {"country": "Luxembourg", "country_code": "LU", "description": "European VAT number\tLU12345678", "prefix": "LU", "type": "eu_vat"}, {"country": "Malta", "country_code": "MT", "description": "European VAT number\tMT12345678", "prefix": "MT", "type": "eu_vat"}, {"country": "Netherlands", "country_code": "NL", "description": "European VAT number\tNL123456789B12", "prefix": "NL", "type": "eu_vat"}, {"country": "Norway", "country_code": "NO", "description": "Norwegian VAT number\t123456789MVA", "prefix": "", "type": "no_vat"}, {"country": "Poland", "country_code": "PL", "description": "European VAT number\tPL1234567890", "prefix": "PL", "type": "eu_vat"}, {"country": "Portugal", "country_code": "PT", "description": "European VAT number\tPT123456789", "prefix": "PT", "type": "eu_vat"}, {"country": "Romania", "country_code": "RO", "description": "European VAT number\tRO1234567891", "prefix": "RO", "type": "eu_vat"}, {"country": "Slovakia", "country_code": "SK", "description": "European VAT number\tSK1234567891", "prefix": "SK", "type": "eu_vat"}, {"country": "Slovenia", "country_code": "SI", "description": "European VAT number\tSI12345678", "prefix": "SI", "type": "eu_vat"}, {"country": "Spain", "country_code": "ES", "description": "Spanish CIF number\tA12345678", "prefix": "ES", "type": "es_cif"}, {"country": "Sweden", "country_code": "SE", "description": "European VAT number\tSE123456789123", "prefix": "SE", "type": "eu_vat"}, {"country": "United Kingdom", "country_code": "GB", "description": "\tUnited Kingdom VAT number\tGB123456789", "prefix": "GB", "type": "gb_vat"}, {"country": "Ukraine", "country_code": "UA", "description": "Ukrainian VAT\t123456789", "prefix": "", "type": "ua_vat"}]
export interface ICountry {
  code: string, country: string, name: string
}
export const COUNTRIES: ICountry[] = []
COUNTRY_DATA.map(c => {
  let trl = getCountryTranslateKey(c.code)
  TRANSLATIONS[trl] = c.country
  COUNTRIES.push({
    code: c.code, country: c.country, name: trl
  })
})


// ATTRIBUTES
function getAttributeTranslateKey (key: string) {
  return "ag.attribute." + key.toLowerCase()
}
const ATTRIBUTE_DATA = [
  {key: 'current_min_temperature', name: 'Min temperature'},
  {key: 'current_avg_temperature', name: 'Avg temperature'},
  {key: 'current_max_temperature', name: 'Max temperature'},
  {key: 'current_min_emc', name: 'Min Moisture'},
  {key: 'current_avg_emc', name: 'Avg Moisture'},
  {key: 'current_max_emc', name: 'Max Moisture'},
  {key: 'current_min_humidity', name: 'Min Humidity'},
  {key: 'current_avg_humidity', name: 'Avg Humidity'},
  {key: 'current_max_humidity', name: 'Max Humidity'},
  {key: 'label', name: 'Label'},
  {key: 'width', name: 'Width'},
  {key: 'length', name: 'Length'}
]
export interface IAttribute {
  key: string, name: string //, description: string
}
export const ATTRIBUTES: IAttribute[] = []
ATTRIBUTE_DATA.map(x => {
  let trl = getAttributeTranslateKey(x.key)
  ATTRIBUTES.push({
    key: x.key, name: trl //, description: ''
  })
  TRANSLATIONS[trl] = x.name
})



// ENTITIES
export interface IEntityType {
  key: string, name: string, description: string, entityType: string
}
export const ENTITIES: IEntityType[] = []
for (let k in agTypes.farmerDeviceTypes) {
  let v = agTypes.farmerDeviceTypes[k]
  let key = v.value

  if (v.disabled) {
    continue
  }

  let e: IEntityType = {
    key: key, entityType: v.entityType,
    name: v.title || ['ag', 'entity', key, 'name'].join('.'),
    description: v.description || ['ag', 'entity', key, 'description'].join('.')
  }
  ENTITIES.push(e)
  TRANSLATIONS[e.name] = e.name
  TRANSLATIONS[e.description] = e.description
}


// ALARMS
const ALARM_DATA = [
  {key: "AMBIENT_EMC_LOW_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "AMBIENT_EMC_HIGH_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "SAMPLE_EMC_LOW_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "SAMPLE_EMC_HIGH_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "AMBIENT_HUMIDITY_LOW_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "AMBIENT_HUMIDITY_HIGH_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "SAMPLE_HUMIDITY_LOW_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "SAMPLE_HUMIDITY_HIGH_ALARM", unit: SENSOR_TYPE.HUM},
  {key: "SAMPLE_TEMPERATURE_HIGH_ALARM", unit: SENSOR_TYPE.TEMP},
  {key: "SAMPLE_TEMPERATURE_LOW_ALARM", unit: SENSOR_TYPE.TEMP},
  {key: "AMBIENT_TEMPERATURE_HIGH_ALARM", unit: SENSOR_TYPE.TEMP},
  {key: "AMBIENT_TEMPERATURE_LOW_ALARM", unit: SENSOR_TYPE.TEMP},
  {key: "BATTERY_LEVEL_ALARM_MIN", unit: null, icon: '/assets/img/signal.png'},
  {key: "SENSOR_ERROR_ALARM", unit: null, color: '#D9461D', icon: '/assets/svg/spear_sensor.svg'},
  {key: "NO_TELEMETRY_ALARM", unit: null}
]

function getAlarmTranslateKey (key: string) {
  return "ag.alarm." + key.toLowerCase() + '.name'
}
export interface IAlarmType {
  key: string, color: string, unit: string, title: string, message: string, icon: string
}
const TEMP_ICON = "/assets/svg/iconset/ag-thermometer.svg"
const EMC_ICON = "/assets/svg/iconset/ag-moisture.svg"

export const ALARM_TYPES: IAlarmType[] = ALARM_DATA.map(x => {
  let color = x.color || agTypes.colors.minColor
  let unit = ''
  let icon = x.icon
  if (x.unit == SENSOR_TYPE.TEMP) {
    color = agTypes.colors.maxColor
    icon = TEMP_ICON
    unit = '%'
  } else if (x.unit == SENSOR_TYPE.HUM) {
    color = agTypes.colors.minColor
    icon = EMC_ICON
    unit = 'C'
  } 

  let trl = getAlarmTranslateKey(x.key)
  let alarm: IAlarmType = {
    key: x.key, color: color, unit: unit, title: trl, icon: icon, message: ''
  }
  TRANSLATIONS[trl] = trl
  return alarm
})

